module.exports = __webpack_public_path__ + "img/transfer-success.9c37c2ea.svg";